<template>
    <div class="article-list-section">
        <!-- 2 图文 -->
        <van-row v-if="dataItem" class="article-list-section-box" @click.prevent="go_article_detail(dataItem)">
            <van-col class="article-list-section-left">
                <van-image
                    v-if="dataItem.cover_img"
                    fit="cover"
                    class="article-list-content-imgs"
                    :src="dataItem.cover_img"
                    width="100%"
                    height="73"
                />
                <div class="article-list-section-left-zl" v-if="dataItem.type === 2">
                    <img src="/static/v4/assembly/icon_list_tag_column.svg" alt="" />
                </div>
            </van-col>

            <van-col class="article-list-content">
                <div class="article-list-title">
                    {{ dataItem.title | omitTitle }}
                </div>
                <div class="article-list-content-detail">
                    <div v-if="dataItem.type === 2">共{{ dataItem.total_count }}篇 {{ dataItem.view_count }}人阅读</div>
                    <div v-else>
                        <span>{{ dataItem.created_at | formatTime }}</span>
                        <span>{{ dataItem.view_count }}人阅读</span>
                    </div>
                </div>

                <van-button type="primary" v-if="!dataItem.is_subscribe && dataItem.type === 2" @click.stop="handleStatus(dataItem)">
                    <img src="@/assets/medical/medical-follow.svg" />
                    关注
                </van-button>
                <van-button v-if="dataItem.is_subscribe && dataItem.type === 2" @click.stop="handleStatus(dataItem)">
                    已关注
                </van-button>
            </van-col>
        </van-row>
    </div>
</template>

//
<script>
// import Interface from '@/util/interface'
import { formatDate } from '@/util/date.js'

export default {
    name: 'Article',
    props: {
        dataItem: {
            type: Object,
            required: true
        },
        contentItem: {
            type: Object
        },
        wapperFn: {
            type: Boolean,
            default: false
        }
    },

    filters: {
        omitTitle(value) {
            if (value.length > 22) {
                return value.slice(0, 22) + '...'
            } else {
                return value
            }
        },
        formatTime(value) {
            const tmp = value.substr(0, 10)
            if (!tmp.match('年')) {
                return formatDate(tmp, 'Y年M月D日')
            } else {
                return value
            }
        }
    },
    methods: {
        go_article_detail(row) {
            if (!this.wapperFn) {
                console.log('内部触发')
            } else {
                this.$emit('goDetail', row)
            }
        },
        handleStatus(row) {
            this.$emit('hadnleStatus', row)
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/components/variable.scss';
@import '@/styles/verify.scss';

.article-list-section {
    background-color: #ffffff;
    border-radius: 10px 10px 0px 0px;
    border-bottom: 1px solid #f2f2f2;
    padding-bottom: 20px;
    padding-top: 16px;
    position: relative;

    .article-list-title {
        @include ContentStyle;
        text-align: justify;
        display: -webkit-box;
        .light {
            color: #0fb7ad;
        }
    }

    .article-list-content {
        text-align: left;
        position: relative;
        height: 80px;
        padding-right: 0px;
        width: 210px !important;

        &-detail {
            margin-top: 10px;
            width: 100%;
            letter-spacing: 0;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #9d9d9d;
            .float-right {
                float: right;
                padding-right: $font16;
            }
            div {
                display: inline-block;
            }
        }

        &-img {
            width: 112px;
            height: 72px;
            border-radius: 6px;
            >>> .van-image__img {
                border-radius: 6px;
            }
            img {
                width: 112px;
                border-radius: 6px;
            }
        }
    }

    .article-list-section-left-zl {
        position: absolute;
        left: 0px;
        top: 0px;
        border-radius: 3px;
        &.active {
            background-image: linear-gradient(135deg, #ffa3af 0%, #ff555e 100%);
            border-radius: 6px 3px 3px 3px;
        }
    }

    .article-list-section-left {
        border-radius: 6px;
        // margin-right: 10px;
    }
    .article-list-content {
        width: 193px;
        height: 78px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .article-list-content-imgs {
        border-radius: 6px;
        /deep/ .van-image__img {
            width: 130px;
            height: 72px;
            border-radius: 6px;
        }
    }

    .article-list-section-left-top {
        position: absolute;
        top: 4px;
        left: 4px;
        width: 18px;
        height: 18px;
        border-radius: 3px;
        img {
            width: 18px;
            height: 18px;
            border-radius: 3px;
        }
    }
    .article-list-section-box:after {
        padding-top: 0;
        margin-bottom: 0;
    }

    .van-button--primary {
        position: absolute;
        right: -10px;
        bottom: -8px;

        width: 65px;
        height: 30px;
        background: #feeed5;
        line-height: 18px;
        box-shadow: 0px 2px 6px 0px rgba(239, 44, 58, 0.1);
        border-radius: 17px;
        border: none;
        padding: 0px;
        font-size: 13px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #b6855e;
    }

    .van-button--default {
        position: absolute;
        right: -10px;
        bottom: -8px;
        background: rgba(221, 221, 221, 0.3);
        width: 71px;
        height: 30px;
        border-radius: 17px;
        border: none;
        padding: 0px;

        font-size: 13px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #907970;
        line-height: 18px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/case/components/article.vue